import { render, staticRenderFns } from "./PrivacyRequest.vue?vue&type=template&id=6533e7e0&scoped=true&"
import script from "./PrivacyRequest.vue?vue&type=script&lang=js&"
export * from "./PrivacyRequest.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyRequest.vue?vue&type=style&index=0&id=6533e7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6533e7e0",
  null
  
)

export default component.exports